/**
 * Report
 */

import Config from '../Config';
import Util from '../Util';
import Template from './Template';

let INSTANCE: Report = null;

class Report {
  private $id: string;

  private maxCount: number = 20;

  private wrapperId: string;

  private $node: any;

  private $modal: any;

  private articleId: string;

  private abstractcommentId: string;

  private writer: string;

  private commentId: string;

  constructor($parent: any, writer: string, wrapperId?: string) {
    this.$id = 'ncCommunityReport';
    this.maxCount = 20;
    this.wrapperId = wrapperId || 'ncCommunityView';
    this.$node = jQuery(Template.report(this.$id));
    this.$modal = jQuery(Template.modal(this.$id + 'Modal'));
    this.articleId = Util.getParams().articleId;
    this.commentId = '';
    this.writer = writer;
    $parent.append(this.$modal, this.$node);
    this.addEvent();

    if (!INSTANCE) {
      INSTANCE = this;
    }

    return INSTANCE;
  }

  public setUser(writer: string) {
    this.writer = writer;
  }

  public getUser() {
    return this.writer;
  }

  public show() {
    // 모든 layer hide
    jQuery('.co-layer-container').removeClass('is-active');
    jQuery('.co-layer-modal').removeClass('is-active');

    jQuery(`#${this.$id} input[type=radio]:eq(0)`).prop('checked', true);

    this._reportedCount((data: any) => {
      let result = data;

      if (result.result || result.result === '0' || result.result === 0) {
        result = data.result;
      }

      if (result !== this.maxCount && result !== -1) {
        this.$node.find('.wrap-count .count').text(this.maxCount - result);
        this.$node.find('.target').text(this.writer);
        this.$node.addClass('is-active');
        this.$modal.addClass('is-active');
      } else if (result === -1) {
        Config.alert(Config.L10N.report_already_have_done);
      } else {
        Config.alert(Config.L10N.report_info);
      }
    });
  }

  public hide() {
    this.$node.removeClass('is-active');
    this.$modal.removeClass('is-active');
  }

  private _reportedCount(callback: any) {
    const getPromise: any = Util.get(Config.todayReportedCount(), 'GET');
    getPromise.then(
      (data: any) => {
        if (callback) {
          callback(data);
        }
      },
      (data: any) => {
        Config.apiError(data);
      }
    );
  }

  private addEvent() {
    // 메뉴
    // @TODO
    // jQuery( 'body' ).on( 'click', `#${this.wrapperId} .co-btn-report`, ( evt ) => {
    jQuery('body').on('click', `.${Config.COMMUNITY_NODE} .co-btn-report`, evt => {
      evt.preventDefault();

      if (Config.isMobileSdk) {
        location.href = Config.mobileSdk.report();
        return;
      }

      this.show();
    });

    // 닫기 버튼
    jQuery('body').on('click', `#${this.$id} .co-btn-close`, evt => {
      evt.preventDefault();
      this.hide();
    });

    // 취소 버튼
    jQuery('body').on('click', `#${this.$id} .reportCancel`, evt => {
      evt.preventDefault();
      this.hide();
    });

    // need to work L10N msg
    jQuery('body').on('click', `#${this.$id} .reportFinish`, evt => {
      evt.preventDefault();
      const value = jQuery(':radio[name="reportCase"]:checked').val();
      if (!value) {
        Config.alert(Config.L10N.report_reason);
        return;
      }

      this.submit(
        {
          reason: value
        },
        (data: any) => {
          if (data && data.toString() === '-1') {
            Config.alert(Config.L10N.report_already_have_done);
          } else {
            Config.alert(Config.L10N.report_have_done);
          }

          this.hide();
        }
      );
    });
  }

  private submit(data: any, callback: any) {
    const _post: any = Util.get(
      Config.reportArticle({
        board: Config.board,
        articleId: this.articleId
      }),
      'POST',
      data
    );
    _post.then(
      (result: any) => {
        if (callback) {
          callback(result);
        }
      },
      (result: any) => {
        Config.apiError(result);
      }
    );
  }
}

export default Report;
